<div class="content-wrapper">
  <div class="row">
    <div class="col-12 grid-margin">
      <div class="card">
        <div class="card-body">
          <div class="card-title">
            <!-- <h4 class="card-title" *ngIf="!multipleEmployees">Create New Employee</h4> -->
            <h4 class="card-title">Upload Employees</h4>
            <!-- <button class="btn btn-primary mr-2">Upload Employees</button> -->
            <!-- <button class="btn btn-primary mr-2" (click)="uploadOption()" *ngIf="multipleEmployees">Add Employee</button> -->
          </div>
          <app-file-upload ></app-file-upload>
          <!-- <form class="forms-sample" #ngNewEmployeeForm="ngForm" name="form"
            (ngSubmit)="ngNewEmployeeForm.form.valid && onSubmit()" *ngIf="!multipleEmployees"> -->

            <!-- <div class="row">
              Contract -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="contract">Labour Request Form</label>
                  <select class="form-control" required [(ngModel)]="selectedContractId" name="selectedContractId" #Erequest="ngModel">
                    <option >--Select Contract--</option>
                    <option *ngFor="let contract of Contracts" [value]="contract.id">{{contract.reference}} </option>
                  </select>
                  <p *ngIf="ngNewEmployeeForm.submitted && Erequest.errors" style="color: red;">
                    Please select associated request form
                  </p>
                </div>
              </div>

              <div class="col"></div>
            </div> -->

            <!-- <div class="row" *ngIf="selectedContractId > 0"> -->
              <!-- First Name -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">First name</label>
                  <input type="text" class="form-control" id="firstName" placeholder="First name" name="firstName"
                    [(ngModel)]="firstName" #Efirstname="ngModel" required>
                  <p *ngIf="ngNewEmployeeForm.submitted && Efirstname.errors" style="color: red;">
                    Please enter first name
                  </p>
                </div>
              </div> -->

              <!-- Last Name  -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Last name</label>
                  <input type="text" class="form-control" id="lastName" placeholder="Last name" name="lastName"
                    [(ngModel)]="lastName" required #Elastname="ngModel">
                    <p  *ngIf="ngNewEmployeeForm.submitted && Elastname.errors" style="color: red;">
                      Last name is required!
                    </p>
                </div>
              </div>
            </div> -->

            <!-- <div class="row" *ngIf="selectedContractId > 0"> -->
              <!-- Email -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Email</label>
                  <input type="email" class="form-control" id="email" placeholder="Email address" name="email"
                    [(ngModel)]="email" required #Eemail="ngModel">
                    <p  *ngIf="ngNewEmployeeForm.submitted && Eemail.errors" style="color: red;">
                      Email is required!
                    </p>
                </div>
              </div> -->

              <!-- Phone Number  -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Phone Number</label>
                  <input type="number" class="form-control" id="phoneNumber" placeholder="080XXXXXXXX"
                    name="phoneNumber" [(ngModel)]="phoneNumber" required #Ephone="ngModel">
                    <p  *ngIf="ngNewEmployeeForm.submitted && Ephone.errors" style="color: red;">
                      Phone number is required!
                    </p>
                </div>
              </div>
            </div> -->

            <!-- <div class="row" *ngIf="selectedContractId > 0"> -->
              <!-- Gender -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="contract">Gender</label>
                  <select class="form-control" required [(ngModel)]="selectedGender" name="selectedGender" #Egender="ngModel">
                    <option value="0">--Select Gender--</option>
                    <option *ngFor="let gender of Gender | keyvalue" [value]="gender.key">{{gender.value}} </option>
                  </select>
                  <p  *ngIf="ngNewEmployeeForm.submitted && Egender.errors && Egender.value == 0" style="color: red;">
                    Gender is required!
                  </p>
                </div>
              </div> -->

              <!-- Labour Rate -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="contract">Labour Rate (optional)</label>
                  <input type="number" class="form-control" id="labourRate" name="labourRate"
                    [(ngModel)]="labourRate">

                </div>
              </div>
            </div> -->

            <!-- <div class="row" *ngIf="selectedContractId > 0"> -->
              <!-- Start Date  -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Expected Start Date</label>
                  <input type="date" class="form-control" min="{{ startDate | date: 'yyyy-MM-dd' }}" id="startDate" placeholder="" name="startDate"
                    [(ngModel)]="startDate">
                </div>
              </div> -->

              <!-- End Date  -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Expected End Date</label>
                  <input type="date" class="form-control" id="endDate" min="{{ endDate | date: 'yyyy-MM-dd' }}" placeholder="" name="endDate"
                    [(ngModel)]="endDate">
                </div>
              </div>
            </div> -->

            <!-- <div class="row" *ngIf="selectedContractId > 0"> -->
              <!-- EmployeeClass -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="contract">Employee Classification</label>
                  <select class="form-control" required [(ngModel)]="selectedEmployeeClass"
                    name="selectedEmployeeClass">
                    <option value="">--Select Classification--</option>
                    <option *ngFor="let eClass of EmployeeClass | keyvalue" [value]="eClass.key">{{eClass.value}}
                    </option>
                  </select>
                </div>
              </div> -->

              <!-- Skill -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="contract">Skill</label>
                  <select class="form-control" required [(ngModel)]="selectedSkillId" name="selectedSkillId">
                    <option value="">--Select Skill--</option>
                    <option *ngFor="let skill of Skills" [value]="skill.id">{{skill.name}} </option>
                  </select>
                </div>
              </div> -->

              <!-- Role type -->
              <!-- <div class="col">
                <div class="form-group">
                  <label for="contract">Role Classification</label>
                  <select class="form-control" required [(ngModel)]="selectedRoleType" name="selectedRoleType">
                    <option value="">--Select Classification--</option>
                    <option *ngFor="let eType of RoleType | keyvalue" [value]="eType.key">{{eType.value}} </option>
                  </select>
                </div>
              </div>
            </div> -->

            <!-- <button *ngIf="selectedContractId > 0" type="submit" class="btn btn-primary mr-2">Submit</button>
            <button class="btn btn-light">Cancel</button> -->
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</div>